import { readJson, writeJson } from 'src/views/NewAnalysis/model/storage'

// ----------------------------------------------------------------------
// "Not now" on a suggestion hides its setup for DISMISS_DAYS days, per user in this
// browser: { [signature]: dismissedAtMs }. Storage may be blocked; readJson and
// writeJson never throw, and a failed write only means it is not remembered.
// ----------------------------------------------------------------------

export const DISMISS_DAYS = 7
const DISMISS_MS = DISMISS_DAYS * 24 * 60 * 60 * 1000
const MAX_ENTRIES = 200

export const dismissedKey = (userKey) => `genesus.home.suggestions.dismissed.${userKey || 'anonymous'}`

/** Only well-formed entries still in force, newest first, at most MAX_ENTRIES. */
export const pruneDismissed = (value, now = Date.now()) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return {}
  const entries = Object.entries(value)
    .filter(([signature, at]) => signature && typeof at === 'number' && Number.isFinite(at) && now - at < DISMISS_MS)
    .sort((a, b) => b[1] - a[1])
    .slice(0, MAX_ENTRIES)
  return Object.fromEntries(entries)
}

export const loadDismissed = (userKey, now = Date.now()) => pruneDismissed(readJson(dismissedKey(userKey)), now)

export const saveDismissed = (userKey, dismissed, now = Date.now()) =>
  writeJson(dismissedKey(userKey), pruneDismissed(dismissed, now))

export const dismiss = (dismissed, signature, now = Date.now()) => ({ ...dismissed, [signature]: now })

export const undismiss = (dismissed, signature) => {
  const next = { ...dismissed }
  delete next[signature]
  return next
}

export const isDismissed = (dismissed, signature, now = Date.now()) => {
  const at = dismissed?.[signature]
  return typeof at === 'number' && now - at < DISMISS_MS
}
